module.exports = __webpack_public_path__ + "ffa996aa74f77c2d6c4bd651c83893fd.png";